import * as React from 'react';
import PropTypes from 'prop-types';
import {Button, Form, FormInput, FormTextArea} from "semantic-ui-react";
import {translate} from "react-i18next";
// import Toggle from "../extensions/Toggle";
import {FormLabel, Toggle} from "../extensions";
import TextIcon from 'material-ui/svg-icons/editor/short-text';

const DEFAULT_SERVICE = {
	service_id: null,
	title: '',
	description: ''
};


class ServiceForm extends React.Component {
	static propTypes = {
		isSaving: PropTypes.bool,
		onSave: PropTypes.func.isRequired,
		onDismiss: PropTypes.func,
		service: PropTypes.object,
		showActive: PropTypes.bool
	};
	static defaultProps = {
		isSaving: false,
		onSave: () => alert('ServiceForm::onSave() not implemented'),
		service: null,
		showActive: false
	};
	state = {
		form: {
			service_id: null,
			title: '',
			description: ''
		}
	};
	
	set = (name, value) => this.setState(state => ({
		...state,
		form: {
			...state.form,
			[name]: value
		}
	}));
	
	handleServiceProp = (service) => this.setState({form: service ? service : DEFAULT_SERVICE});
	
	componentDidMount() {
		this.handleServiceProp(this.props.service);
	}
	
	componentWillReceiveProps(props) {
		this.handleServiceProp(props.service);
	}
	
	render = () => {
		const {t, isSaving, onSave, onDismiss, showActive} = this.props;
		const {form } = this.state;
		return (
			<Form loading={isSaving} onSubmit={() => onSave(this.state.form, () => {
				console.info('calling on success func');
				if ( onDismiss ) {
					console.info('should dissmiss view');
					onDismiss();
				}
			})}>
				{form.service_id &&
					<Form.Field>
						{/*<TextField fullWidth hintText={'keine Service-ID'} floatingLabelText={'Service-ID'} value={form.service_id} disabled/>*/}
						<FormInput labelPosition={'left'} value={form.service_id} readOnly>
							<FormLabel>ID</FormLabel>
							<input/>
						</FormInput>
					</Form.Field>
				}
				{showActive &&
					<Form.Field>
						<Toggle toggled={form.active} onToggle={(_, value) => this.set('active', value)} label={'Aktiv'} labelPosition={'right'} />
					</Form.Field>
				}
				{showActive &&
					<Form.Field>
						<Toggle toggled={form.tuv} onToggle={(_, value) => this.set('tuv', value)} label={'TÜV / HU'} labelPosition={'right'} />
					</Form.Field>
				}
				<Form.Field>
					{/*<TextField fullWidth={true} required={true} hintText={'Titel'} value={form.title} floatingLabelText={'Titel'} onChange={(_, value) => this.set('title', value)}/>*/}
					<FormInput labelPosition={'left'} value={form.title} onChange={(_, el) => this.set('title', el.value)} required label={'Titel/Name'}>
						<FormLabel><TextIcon/></FormLabel>
						<input/>
					</FormInput>
					{form.service_id && <div>Übersetzung: {t([`service.name.service-${form.service_id}`, 'service.no-translation'])}</div>}
				</Form.Field>
				<Form.Field>
					{/*<TextField fullWidth={true} multiLine={true} hintText={'Beschreibung'} value={form.description} floatingLabelText={'Beschreibung'}  onChange={(_, value) => this.set('description', value)}/>*/}
					<FormTextArea
						label={'Beschreibung'}
						value={form.description}
						autoHeight
						onChange={(_, el) => this.set('description', el.value)}
					/>
				</Form.Field>
				<Form.Field style={{overflow: 'hidden'}}>
					<Button floated={'right'} positive={true} inverted={true}>
						{t('actions.save')}
					</Button>
				</Form.Field>
				{/*<pre>{JSON.stringify(this.state, null, 4)}</pre>*/}
			</Form>
		);
	};
}

export default translate()(ServiceForm);


// WEBPACK FOOTER //
// ./src/components/ServiceForm.js